import { getCanvasCoord } from '../../utils/utils.js'

export const handleBlockEraserDown = (e, state) => {
  const {
    clientCoord,
    translate,
    scope,
    scaleRatio,
    blockEraserScaledHalfSizeRef,
    setIsBlockEraserActive,
    setBlockEraserPosition,
  } = state

  if (e.width >= 100 && e.height >= 100) {
    const eraserPositionX = getCanvasCoord(clientCoord, translate, scope).x
    const eraserPositionY = getCanvasCoord(clientCoord, translate, scope).y
    // alert(scaleRatio.current)
    setIsBlockEraserActive(true)
    blockEraserScaledHalfSizeRef.current = {
      width: Math.floor((e.width * scaleRatio.current) / scope / 4),
      height: Math.floor((e.height * scaleRatio.current) / scope / 4),
    }
    setBlockEraserPosition({
      top: eraserPositionY - blockEraserScaledHalfSizeRef.current.height,
      left: eraserPositionX - blockEraserScaledHalfSizeRef.current.width,
    })
    return true
  }
  return false
}
